
const $ = s => document.querySelector(s);
const money = c => new Intl.NumberFormat(document.documentElement.lang||"en",{style:"currency",currency:window.HUSH_CURRENCY||"USD"}).format(c/100);
function toast(m){ const t=$("#toast"); t.textContent=m; t.classList.add("show"); setTimeout(()=>t.classList.remove("show"),2000); }

/* Shopify AJAX cart */
async function getCart(){ return (await fetch("/cart.js")).json(); }
function renderCart(cart){
  const lines=$("#lines"); lines.innerHTML="";
  if(!cart.items.length) lines.innerHTML='<p class="empty">Your cart is empty.</p>';
  cart.items.forEach(it=>{
    const d=document.createElement("div"); d.className="line";
    const vt = it.variant_title && it.variant_title!=="Default Title" ? it.variant_title+" · " : "";
    d.innerHTML=`<img src="${it.image||""}" alt=""><div><strong>${it.product_title}</strong><small>${vt}Qty ${it.quantity}</small><button class="rm" type="button" data-key="${it.key}">Remove</button></div><div>${money(it.final_line_price)}</div>`;
    lines.appendChild(d);
  });
  lines.querySelectorAll(".rm").forEach(b=>b.onclick=async()=>{
    const r=await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:b.dataset.key,quantity:0})});
    renderCart(await r.json());
  });
  $("#cartCount").textContent=cart.item_count;
  $("#total").textContent=money(cart.total_price);
  const co=$("#checkout"); co.style.pointerEvents=cart.item_count?"":"none"; co.style.opacity=cart.item_count?"":".5";
}
async function addToCart(variantId,qty){
  const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:variantId,quantity:qty}]})});
  if(!r.ok){ const e=await r.json().catch(()=>({})); toast(e.description||"Couldn't add to cart"); return; }
  renderCart(await getCart()); toast(`Added ${qty} to cart`);
  $("#drawer").setAttribute("open","");
}
const drawer=$("#drawer");
$("#openCart").onclick=async()=>{ renderCart(await getCart()); drawer.setAttribute("open",""); $("#closeCart").focus(); };
const closeCart=()=>drawer.removeAttribute("open");
$("#closeCart").onclick=closeCart; $("#scrim").onclick=closeCart;
document.addEventListener("keydown",e=>{ if(e.key==="Escape") closeCart(); });

/* buy boxes */
document.querySelectorAll("[data-buybox]").forEach(box=>{
  let qty=1; const out=box.querySelector("output");
  box.querySelector("[data-plus]").onclick=()=>{ qty=Math.min(10,qty+1); out.value=qty; };
  box.querySelector("[data-minus]").onclick=()=>{ qty=Math.max(1,qty-1); out.value=qty; };
  const add=box.querySelector("[data-add]");
  if(add) add.onclick=()=>addToCart(+add.dataset.add,qty);
});
/* gallery thumbs */
document.querySelectorAll(".thumbs").forEach(t=>{
  const main=t.parentElement.querySelector(".main img");
  t.querySelectorAll("button").forEach(b=>b.onclick=()=>{ main.src=b.dataset.src; t.querySelectorAll("button").forEach(x=>x.setAttribute("aria-current",false)); b.setAttribute("aria-current",true); });
});
